export default "__VITE_ASSET__CT0s_Q3p__"